module.exports = __webpack_public_path__ + "static/media/covi_too_was_col.e49d0468.png";